import { baseLanguage } from './Languages';

type LanguageSource = {
  language?: string;
  on: (event: 'languageChanged', listener: (language: string) => void) => void;
};

/**
 * Keeps <html lang> on the language the UI is actually shown in. index.html ships a static
 * lang="en", so without this a German shop is announced to screen readers, hyphenation and
 * browser translation as English. Region tags (de-CH, pl_PL) collapse to the base code, matching
 * how the catalogs are keyed.
 *
 * Extracted from Localization.js (which calls i18n.init() on import) so it can be unit-tested.
 */
export function applyDocumentLanguage(language?: string | null) {
  const base = baseLanguage(language);

  if (base && typeof document !== 'undefined') {
    document.documentElement.lang = base;
  }
}

export function bindDocumentLanguage(i18n: LanguageSource) {
  // The detector is async, so i18n.language may still be unset here; languageChanged covers that.
  applyDocumentLanguage(i18n.language);
  i18n.on('languageChanged', applyDocumentLanguage);
}
